import React, { useState, useEffect } from "react";

// react router
import { useHistory } from "react-router-dom";

// redux
import { connect } from "react-redux";

// styles
import Container from "./styles/Container";

// includes
import {
	Footer,
	Body
} from "./includes";
import { addCustomer, addCustomerAddress } from "utlis/Apis/Customers_API";

// react toastify
import { toast } from "react-toastify";

// app messages
import {
	ERROR_WHILE__NAME,
	UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";
import { createOrder } from "utlis/Apis/Cart_API";

// actions
import { emptyCart } from "redux/actions/actionCart";

function Cart(props) {
	// props
	const {
		currentUser,
		commonToken,
		tempOrderId,
		emptyCart
	} = props

	// consts
	const history = useHistory();

	// states
	const [allCheckoutDetails, setAllCheckoutDetails] = useState({})
	const [pageLoading, setPageLoading] = useState(false)

	const createOrderProcess = data => {
		if (data) {
			// creating order
			createOrder(commonToken ?? "", data).then(res => {
				const resData = res.data
				if (resData?.success) {

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.success("Order placed successfully", {
						autoClose: 2500,
						onClose: () => { },
					});

					// empty the cart
					emptyCart()

					history.push({
						pathname: "/cart-success",
						state: {
							orderId: resData.order_id
						}
					})
				}

				if (resData?.error) {
					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
						autoClose: 2500,
						onClose: () => { },
					});
				}
			}).catch(err => {
				// disabling page loading
				setPageLoading(false)
				console.log(`${ERROR_WHILE__NAME} createOrder`, err.message);

				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 2500,
					onClose: () => {
						// disabling page loading
						setPageLoading(false)
					},
				});
			})
		}
	}

	const handleCreateOrder = () => {
		if (allCheckoutDetails) {
			// enabling page loading
			setPageLoading(true)

			// checking if the user is a new user then create one
			if (!currentUser) {
				const customerInfo = {
					email_verified: "0",
					status: "1",
					retailer_type: "",
					activate_bank_payment: "",
					activate_net30: "",
					email: allCheckoutDetails.email,
					password: "Pass@123456!",
					license_number: "",
					business_license: "",
					first_name: allCheckoutDetails.shippingAddressDetails.shipping_first_name,
					middle_name: "",
					last_name: allCheckoutDetails.shippingAddressDetails.shipping_last_name,
					company_name: "",
					is_guest: 1
				}

				// adding customer api
				addCustomer(commonToken ?? "", customerInfo).then(res => {
					// disabling page loading
					setPageLoading(false)

					const resData = res.data

					// if request is success
					if (resData?.success) {
						// creatig order
						const requiredData = {
							temp_order_id: tempOrderId,
							customer_id: resData.user_id,
							payment_processor: allCheckoutDetails.shippingMethod,
							stripe_token: "",
							card_number: "1234 5678 9012 3456",
							card_expiry_month: "12",
							card_expiry_year: "2025",
							card_cvv: "123",
							shipping_amount: "",
							coupon_code: "",
							coupon_discount: "",
							shipping_person: {
								address_type: "shipping",
								...allCheckoutDetails.shippingAddressDetails
							},
							billing_person: allCheckoutDetails.shippingMethod ? {
								address_type: "billing",
								...allCheckoutDetails.shippingAddressDetails
							} : {
								address_type: "billing",
								...allCheckoutDetails.billingAddressDetails
							},
						}

						// adding shipping address to the database
						addCustomerAddress(commonToken ?? "", {
							user_id: requiredData.customer_id,
							...requiredData.shipping_person
						}).then(res => {
						}).catch(err => console.log(`${ERROR_WHILE__NAME} addCustomerAddress-shipping`, err.message))

						// adding billing address to the database
						addCustomerAddress("", {
							user_id: requiredData.customer_id,
							...requiredData.billing_person
						}).then(res => {
						}).catch(err => console.log(`${ERROR_WHILE__NAME} addCustomerAddress-billing`, err.message))

						// creating order
						createOrderProcess(requiredData)
					}

					// if request is not success
					if (resData?.error) {
						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.error(UNKNOWN_ERROR_OCCURED, {
							autoClose: 2500,
							onClose: () => { },
						});
					}
				}).catch(err => {
					// disabling page loading
					setPageLoading(false)
					console.log(`${ERROR_WHILE__NAME} addCustomer`, err.message);
				})
			} else { // if the user is an existing user
				const requiredData = {
					temp_order_id: tempOrderId,
					customer_id: currentUser.userId,
					payment_processor: allCheckoutDetails.shippingMethod,
					stripe_token: "",
					card_number: "1234 5678 9012 3456",
					card_expiry_month: "12",
					card_expiry_year: "2025",
					card_cvv: "123",
					shipping_amount: "",
					coupon_code: "",
					coupon_discount: "",
					shipping_person: {
						address_type: "shipping",
						...allCheckoutDetails.shippingAddressDetails
					},
					billing_person: allCheckoutDetails.shippingMethod ? {
						address_type: "billing",
						...allCheckoutDetails.shippingAddressDetails
					} : {
						address_type: "billing",
						...allCheckoutDetails.billingAddressDetails
					},
				}

				// creating order
				createOrderProcess(requiredData)
			}
		}
	}

	return (
		<div className="cart-main-outer-later-added pt-4">
			<div className="container">
				<Body
					pageLoading={pageLoading}
					allCheckoutDetails={allCheckoutDetails}
					setAllCheckoutDetails={data => setAllCheckoutDetails(data)}
					handleCreateOrder={handleCreateOrder}
				/>

				{/* <Footer /> */}
			</div>
		</div>
	);
}

const getDataFromStore = (state) => {
	return {
		currentUser: state.auth.currentUser,
		commonToken: state.auth.commonToken,
		tempOrderId: state.auth.tempOrderId,
	};
};

const dispatchActionsToProps = (dispatch) => {
	return {
		emptyCart: () => dispatch(emptyCart()),
	};
};

export default connect(getDataFromStore, dispatchActionsToProps)(Cart);